export const isPresetDashboard = () => {
  const subPaths = window.location.pathname.split('/');
  return String(subPaths[subPaths.length - 2]).toLocaleLowerCase() === 'preset';
};

export const isSharingDashboard = () => {
  const subPaths = window.location.pathname.split('/');
  return String(subPaths[subPaths.length - 2]).toLocaleLowerCase() === 'sharing';
};

export const isDrillDownDashboard = () => {
  const subPaths = window.location.pathname.split('/');
  return String(subPaths[subPaths.length - 2]).toLocaleLowerCase() === 'drilldown';
};

export const isSavedDashboard = () => {
  const subPaths = window.location.pathname.split('/');
  return String(subPaths[subPaths.length - 2]).toLocaleLowerCase() === 'saved';
};

const getIdFromUrl = () => {
  const subPaths = window.location.pathname.split('/');
  return subPaths[subPaths.length - 1] ?? '';
};

export const getPresetKeyFromUrl = () => {
  if (isPresetDashboard()) {
    return getIdFromUrl();
  }
  return '';
};

export const getSavedDashboardIdFromUrl = () => {
  if (isSavedDashboard()) {
    return getIdFromUrl();
  }
  return '';
};

export const getSharingIdFromUrl = () => {
  if (isSharingDashboard()) {
    return getIdFromUrl();
  }
  return '';
};
